// extracted by mini-css-extract-plugin
module.exports = {"smallMobileView":"555","mediumMobileView":"768","mobileView":"992","maxWidth":"1340","navigation":"1120"};